import httpClient from "../http/http-client";
import { IEsrsTable, IGeneratedSecrReportResponse, IGhgTable, IReportSECRGenerate, ISecrNarratives, ISecrNarrativesResponse } from './generated-report.model';

export default class GeneratedReportService {
  http;

  constructor() {
    this.http = httpClient
  }

  async createGeneratedReport(reportDetails: IReportSECRGenerate): Promise<IGeneratedSecrReportResponse> {
    return this.http.post(`generated-report`, reportDetails)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getReport(id: string): Promise<IGeneratedSecrReportResponse> {
    return this.http.get(`generated-report/${id}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getAllReports(): Promise<IGeneratedSecrReportResponse[]> {
    return this.http.get(`generated-report`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async completeSecrReport(id: string, secrReportId: string): Promise<any> {
    return this.http.post(`generated-report/${id}/complete`, {secrReportId: secrReportId})
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      })
  }

  async updateSecrNarratives(id: string, narratives: ISecrNarratives): Promise<ISecrNarrativesResponse> {
    return this.http.patch(`generated-report/${id}/narratives`, narratives)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getBCorp(queryString?: string): Promise<any> {
    return this.http.get(`generated-report/b-corp${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getEsrs(reportPeriodId: string): Promise<IEsrsTable> {
    return this.http.get(`generated-report/esrs/${reportPeriodId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getGhg(reportPeriodId: string): Promise<IGhgTable> {
    return this.http.get(`generated-report/ghg/${reportPeriodId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getGhgPdf(reportPeriodId: string): Promise<Blob> {
    return this.http.get(`generated-report/ghg/${reportPeriodId}/pdf`, { responseType: 'blob' })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getWebpage(reportType: string, reportPeriodId: string): Promise<any> {
    return this.http.get(`generated-report/webpage/${reportType}/${reportPeriodId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }
}